import { useInjection } from 'inversify-react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { IAttachmentUploadService } from '../attachmentUploadService';
import { AttachmentUploadDropdown } from '../components/AttachmentsUploadDropdown';

export const AttachmentUploadDropdownContainer = observer((): ReactElement => {
  const attachmentUploadService = useInjection(IAttachmentUploadService.$);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [attachmentUploadToCancel, setAttachmentUploadToCancel] = useState('');

  const handleCancelUpload = (attachmentId: string): void => {
    setIsModalOpen(true);
    setAttachmentUploadToCancel(attachmentId);
  };

  const handleCancelUploadConfirm = async (): Promise<void> => {
    await attachmentUploadService.cancelUpload(attachmentUploadToCancel);
    handleToggleConfirmationModal();
  };

  const handleToggleConfirmationModal = (): void => {
    setIsModalOpen(false);
    setAttachmentUploadToCancel('');
  };

  return (
    <AttachmentUploadDropdown
      progressData={toJS(attachmentUploadService.data.progressData)}
      showConfirmModal={isModalOpen}
      onCancelUpload={handleCancelUpload}
      onCancelUploadConfirm={handleCancelUploadConfirm}
      onToggleConfirmModal={handleToggleConfirmationModal}
    />
  );
});
